import top5img from '../img/badge/top5original.png'
import bestsquad from '../img/badge/squadoriginal.png'
import rocking from '../img/badge/rockingoriginal.png'
import proactive from '../img/badge/proactivaoriginal.png'

// import trivia from '../img/portfolio/triviajq.png'
import booking from '../img/portfolio/flightbook.png'
import liftJQ from '../img/portfolio/lift_jq.png'
import liftReact from '../img/portfolio/lyftReact.png'
import memory from '../img/portfolio/memory_jq.png'
import foro from '../img/portfolio/foro_react.png'
import trello from '../img/portfolio/trelloReact.png'
import scoreboardR from '../img/portfolio/scoreboard_React.png'
import sushi from '../img/portfolio/sushistore.png'
// import hacknemiaR from '../img/portfolio/hacknemiaSA.png'

// new portfolio thumbnails
import trivia from '../img/portfolio/triviasc.png'
import pandero from '../img/portfolio/pandero_1.png'
import innova from '../img/portfolio/innova_1.png'
import hacknemiaR from '../img/portfolio/hacknemia_1.png'

const bio = [
  {
    id: '10/26/2017 12:24:20',
    name: 'Milagros Sharmyn Rodríguez Coronado',
    campus: 'Arequipa',
    Labcode: 'AQP20171384',
    bio:
        // 'Hi, I’m Mili, a passionate, highly enthusiastic programmer-coder. Have strong desire for knowledge and challenges. I’m a fast learner who picks up new skills quickly. Self-educated, self -motivated, hard-worker and versatile person.',
        'Hi, I’m a digital enthusiast with a strong passion for technology and innovation. Have a strong desire for knowledge and challenges. I’m a fast learner who picks up new skills quickly. Self-educated, hard-worker and versatile person.',
    englishLevel: 'Intermedio',
    linkedin: 'www.linkedin.com/in/milagros-rodriguez-coronado',
    portfolio: '',
    github: 'sharmynrodriguez@gmail.com',
    badges:
        'Cuadro de Honor, Best team player, La mas proactiva, Rocking Spring',
    html: [
      {
        name: 'Landing Page - Panda',
        ghPages: 'https://sharmyn28.github.io/Love-Panda/',
        image: 'https://getuikit.com/v2/docs/images/placeholder_600x400.svg',
        code: 'https://github.com/Sharmyn28/Love-Panda'
      },
      {
        name: 'Buying Fruits',
        ghPages: 'https://sharmyn28.github.io/lista-frutas/',
        image: 'https://getuikit.com/v2/docs/images/placeholder_600x400.svg',
        code: 'https://github.com/Sharmyn28/lista-frutas'
      }
    ],
    jquery: [
      {
        name: 'Trivia',
        ghPages: 'https://sharmyn28.github.io/trivia/',
        image: trivia,
        code: 'https://github.com/Sharmyn28/trivia'
      },
      {
        name: 'Booking Tickets',
        ghPages: 'https://sharmyn28.github.io/reservaDeBus/',
        image: booking,
        code: 'https://github.com/Sharmyn28/reservaDeBus'
      },
      {
        name: 'Lift - Phone',
        ghPages: 'https://sharmyn28.github.io/IV-Sprint/',
        image: liftJQ,
        code: 'https://github.com/Sharmyn28/IV-Sprint'
      },
      {
        name: 'Memory Puzzle',
        ghPages: 'https://sharmyn28.github.io/Memory_Puzzle/',
        image: memory,
        code: 'https://github.com/Sharmyn28/Memory_Puzzle'
      }
    ],
    css: [
      {
        name: 'Landing Page - Koala',
        ghPages: 'https://sharmyn28.github.io/koala2/',
        image: 'https://getuikit.com/v2/docs/images/placeholder_600x400.svg',
        code: 'https://github.com/Sharmyn28/koala2'
      },
      {
        name: 'Landing Page',
        ghPages: 'https://sharmyn28.github.io/Proyecto-Maquetado/',
        image: 'https://getuikit.com/v2/docs/images/placeholder_600x400.svg',
        code: 'https://github.com/Sharmyn28/Proyecto-Maquetado'
      },
      {
        name: 'Landing Page',
        ghPages: 'https://sharmyn28.github.io/AppLove-flex/',
        image: 'https://getuikit.com/v2/docs/images/placeholder_600x400.svg',
        code: 'https://github.com/Sharmyn28/AppLove-flex'
      }
    ],
    reactRedux: [
      {
        name: 'Foro',
        ghPages: 'https://sharmyn28.github.io/foro/',
        image: foro,
        code: 'https://github.com/Sharmyn28/foro'
      },
      {
        name: 'Trello Firebase',
        ghPages: 'https://sharmyn28.github.io/trello/',
        image: trello,
        code: 'https://github.com/Sharmyn28/trello'
      },
      {
        name: 'Scoreboard',
        ghPages: 'https://sharmyn28.github.io/scoreboard-timer/',
        image: scoreboardR,
        code: 'https://github.com/Sharmyn28/scroreboard-timer'
      }
    ],
    colaborativos: [
      {
        name: 'Lift-React',
        ghPages: 'https://melanieoc.github.io/lyft-react/',
        image: liftReact,
        code: 'https://github.com/melanieoc/lyft-react'
      },
      {
        name: 'Sushi - React',
        ghPages: 'https://sharmyn28.github.io/SUSHI/',
        image: sushi,
        code: 'https://github.com/Sharmyn28/SUSHI'
      },
      {
        name: 'Hacknemia - React',
        ghPages: 'https://hacknemia.firebaseapp.com/',
        // ghPages: 'https://melanieoc.github.io/hackathon/',
        image: hacknemiaR,
        code: 'https://github.com/melanieoc/hackathon'
      }
    ],
    all: [
      {
        name: 'Hacknemia - React',
        ghPages: 'https://hacknemia.firebaseapp.com/',
        // ghPages: 'https://melanieoc.github.io/hackathon/',
        image: hacknemiaR,
        code: 'https://github.com/melanieoc/hackathon'
      },
      {
        name: 'Sushi - React',
        ghPages: 'https://sharmyn28.github.io/SUSHI/',
        image: sushi,
        code: 'https://github.com/Sharmyn28/SUSHI'
      },
      {
        name: 'Booking Tickets',
        ghPages: 'https://sharmyn28.github.io/reservaDeBus/',
        image: booking,
        code: 'https://github.com/Sharmyn28/reservaDeBus'
      },
      // {
      //   name: 'Trivia',
      //   ghPages: 'https://sharmyn28.github.io/trivia/',
      //   image: trivia,
      //   code: 'https://github.com/Sharmyn28/trivia'
      // },
      // {
      //   name: 'Lift - Phone',
      //   ghPages: 'https://sharmyn28.github.io/IV-Sprint/',
      //   image: liftJQ,
      //   code: 'https://github.com/Sharmyn28/IV-Sprint'
      // },
      {
        name: 'Foro',
        ghPages: 'https://sharmyn28.github.io/foro/',
        image: foro,
        code: 'https://github.com/Sharmyn28/foro'
      },
      {
        name: 'Mi Pandero',
        ghPages: 'https://zonadeasociados.pandero.com.pe/portalasociado/login?p=init',
        image: pandero,
        code: 'https://zonadeasociados.pandero.com.pe/portalasociado/login?p=init'
      },
      {
        name: 'Nuevo Innova Family',
        ghPages: 'https://play.google.com/store/apps/details?id=pe.edu.innovaschools.nif&hl=es_PE',
        image: innova,
        code: 'https://innovafamily.pe/'
      }

    ],
    education: [
      {
        title: 'Front-end Developer & Web Design',
        degree: 'Front-end Developer Jr',
        place: 'Laboratoria',
        timeStudies: '6 months',
        years: '2017',
        graduationDate: 2017,
        description: 'At Laboratoria I learned to create user-facing functionality, the environment for everything that users see and touch: content, layout, and interaction. At the same time work on my soft skills and become an agile developer and person.'
      },
      {
        title: 'Industrial Engineering',
        degree: 'Bachelor’s degree',
        place: 'Universidad Católica Santa María',
        timeStudies: '5 years',
        years: '2012 - 2016',
        graduationDate: 2016,
        description: 'During my 5 years of study as an Industrial engineer I learned to find ways to eliminate wastefulness in production processes. Devise efficient ways to use workers, machines, materials, information, and energy to make a product or provide a service.'
      }
    ],
    workExperience: [
      {
        title: 'MARKETING INTERN',
        company: 'Go – Go Car',
        place: 'Cairo, Egypt',
        timeWork: '4 months',
        years: 'Dec 2016 - Mar 2017',
        description: 'Conducted market research being up to date with the latest trends in the industry. Prepared Social Media Content across different platforms. Prepared a Go To Market Strategy, Branding & Marketing Collaterals. Planned all web SEOs.'
      },
      {
        title: 'IT TRAINEE',
        company: 'Farmacéutica del Sur',
        place: 'Arequipa, Perú',
        timeWork: '4 months',
        years: 'Ag 2016 - Dec 2016',
        description: 'Responsible for developing solutions and control Database, using SQL Server. Provide user support as well as support the Coordinator in new IT projects. Provide support to users of Administration and Accounting, remotely or in person. Inventory control IT assets using GLPI.'
      }
    ],
    testimonials: '',
    resume: '',
    professional: [
      {
        skill: 'Team Worker',
        habilidad: 'Trabajo en Equipo',
        image: bestsquad,
        percentage: '70%',
        perComplete: '70',
        numberBadget: 1
      },
      {
        skill: 'Proactive',
        habilidad: 'Proactividad',
        image: proactive,
        percentage: '90%',
        perComplete: '90',
        numberBadget: 3
      },
      {
        skill: 'Excellence',
        habilidad: 'Excelencia',
        image: top5img,
        percentage: '80%',
        perComplete: '80',
        numberBadget: 2
      },
      {
        skill: 'Outstanding',
        habilidad: 'Sobresaliente',
        image: rocking,
        percentage: '70%',
        perComplete: '70',
        numberBadget: 2
      }
    ],
    software: [
      {
        skill: 'VisualStudio',
        image: 'devicon-visualstudio-plain',
        percentage: '70%',
        classComplete: 'percentage70',
        class: 'progress-70'
      },
      {
        skill: 'GitHub',
        image: 'devicon-github-plain',
        percentage: '70%',
        classComplete: 'percentage70',
        class: 'progress-70'
      }
    ],
    code: [
      // {
      //   skill: 'VisualStudio',
      //   image: 'devicon-visualstudio-plain',
      //   percentage: '80%',
      //   classComplete: 'percentage80',
      //   class: 'progress-80'
      // },
      // {
      //   skill: 'GitHub',
      //   image: 'devicon-github-plain-wordmark',
      //   percentage: '80%',
      //   classComplete: 'percentage80',
      //   class: 'progress-80'
      // },
      {
        skill: 'Git',
        image: 'devicon-git-plain',
        percentage: '80%',
        classComplete: 'percentage80',
        class: 'progress-80'
      },
      {
        skill: 'HTML5',
        image: 'devicon-html5-plain-wordmark',
        percentage: '80%',
        classComplete: 'percentage80',
        class: 'progress-80'
      },
      {
        skill: 'CSS3',
        image: 'devicon-css3-plain-wordmark',
        percentage: '70%',
        classComplete: 'percentage70',
        class: 'progress-70'
      },
      {
        skill: 'Bootstrap',
        image: 'devicon-bootstrap-plain-wordmark',
        percentage: '80%',
        classComplete: 'percentage80',
        class: 'progress-80'
      },
      {
        skill: 'JavaScript/ESC6',
        image: 'devicon-javascript-plain',
        percentage: '70%',
        classComplete: 'percentage70',
        class: 'progress-70'
      },
      {
        skill: 'JQuery',
        image: 'devicon-jquery-plain-wordmark',
        percentage: '70%',
        classComplete: 'percentage70',
        class: 'progress-70'
      },
      {
        skill: 'React-Redux',
        image: 'devicon-react-original-wordmark',
        percentage: '60%',
        classComplete: 'percentage60',
        class: 'progress-60'
      },
      {
        skill: 'Sass',
        image: 'devicon-sass-original',
        percentage: '60%',
        classComplete: 'percentage60',
        class: 'progress-60'
      },
      {
        skill: 'Angular',
        image: 'devicon-angularjs-plain',
        percentage: '50%',
        classComplete: 'percentage50',
        class: 'progress-50'
      },
      {
        skill: 'Vue',
        image: 'devicon-vuejs-plain-wordmark',
        percentage: '50%',
        classComplete: 'percentage50',
        class: 'progress-50'
      }
      /* {
          skill: 'Materialize',
          image: 'daf',
          percentage: '80%',
          classComplete: 'percentage80',
          class: 'progress-80',
          url: 'https://berenisser.github.io/assets/img/materialize.png'
      } */
    ]
  }
]

export default bio



// WEBPACK FOOTER //
// ./src/store/DataBase.js